import React from "react";
import { SnackbarProvider } from "notistack";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import CheckCircleOutlineOutlinedIcon from "@material-ui/icons/CheckCircleOutlineOutlined";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import BlockOutlinedIcon from "@material-ui/icons/BlockOutlined";
import { makeStyles, Theme, createStyles } from "@material-ui/core";

/** スタイル */
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    info: {
      padding: "0 10px 0 10px",
      backgroundColor: `${theme.palette.info.main} !important`,
    },
    success: {
      padding: "0 10px 0 10px",
      backgroundColor: `${theme.palette.info.main} !important`,
    },
    warning: {
      padding: "0 10px 0 10px",
      backgroundColor: `${theme.palette.secondary.main} !important`,
    },
    error: {
      padding: "0 10px 0 10px",
      backgroundColor: `${theme.palette.secondary.main} !important`,
    },
    icon: {
      margin: theme.spacing(1),
    },
  })
);

/** Props */
interface Props {
  children: React.ReactNode;
}

/**
 * 複数スナックバー表示プロバイダ
 * https://iamhosseindhv.com/notistack/api
 */
export function MessageBarProvider(props: Props) {
  const classes = useStyles();
  const { children } = props;

  return (
    <SnackbarProvider
      maxSnack={10}
      iconVariant={{
        info: <InfoOutlinedIcon fontSize="small" className={classes.icon} />,
        success: (
          <CheckCircleOutlineOutlinedIcon
            fontSize="small"
            className={classes.icon}
          />
        ),
        warning: (
          <ReportProblemOutlinedIcon
            fontSize="small"
            className={classes.icon}
          />
        ),
        error: <BlockOutlinedIcon fontSize="small" className={classes.icon} />,
      }}
      classes={{
        variantInfo: classes.info,
        variantSuccess: classes.success,
        variantWarning: classes.warning,
        variantError: classes.error,
      }}
    >
      {children}
    </SnackbarProvider>
  );
}

export default MessageBarProvider;
